import _ from 'lodash';
import lottie from 'lottie-web';

const ANIMATION_LIST = ['countDown', 'gameOver', 'goal', 'powder250'];

export default class PreloadAnimation {
  static get list() {
    return ANIMATION_LIST;
  }

  static load(element, key) {
    return new Promise((resolve, reject) => {
      const json = require(`@/animation/${key}/data.json`);
      const bodymovin = lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: json
      });
      bodymovin.addEventListener('loaded_images', () => {
        resolve({
          bodymovin: bodymovin,
          element: element,
          key: key
        });
      });
    });
  }

  static loadItemAll(elementList) {
    const loadItemList = [];
    _.forEach(elementList, element => {
      const loader = PreloadAnimation.loadItem(element);
      loadItemList.push(loader);
    });
    return Promise.all(loadItemList);
  }

  static loadItem(element) {
    return new Promise(resolve => {
      const key = element.dataset.key;
      const json = require(`@/animation/${key}/data.json`);
      const bodymovin = lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: json
      });
      bodymovin.addEventListener('loaded_images', () => {
        resolve({
          bodymovin: bodymovin,
          element: element,
          key: key
        });
      });
    });
  }
}
